var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 2.5C6.21836 2.5 3 5.71836 3 9.6875C3 13.6566 6.21836 16.875 10.1875 16.875C14.1566 16.875 17.375 13.6566 17.375 9.6875C17.375 5.71836 14.1566 2.5 10.1875 2.5Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09375 8.59375H10.3438V13.125",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 13.2812H12.0625",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 5.07812C9.98663 5.07812 9.79027 5.13769 9.62325 5.24929C9.45623 5.36089 9.32606 5.51951 9.24918 5.70509C9.17231 5.89067 9.1522 6.09488 9.19139 6.29189C9.23058 6.4889 9.32731 6.66987 9.46934 6.81191C9.61138 6.95394 9.79235 7.05067 9.98936 7.08986C10.1864 7.12905 10.3906 7.10894 10.5762 7.03207C10.7617 6.9552 10.9204 6.82502 11.032 6.658C11.1436 6.49098 11.2031 6.29462 11.2031 6.09375C11.2031 5.82439 11.0961 5.56606 10.9057 5.37559C10.7152 5.18513 10.4569 5.07812 10.1875 5.07812Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b54e0a116d79c524bf580a3a18eb88b0.svg";
export { ForwardRef as ReactComponent };